// extracted by mini-css-extract-plugin
export default {"root":"NavBar_root__--nhy","heading":"NavBar_heading__0O9qx","title":"NavBar_title__k71Ry","sticky":"NavBar_sticky__50obo"};